import { IComponentController, IScope } from 'angular';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemActionImportationClass } from '../../../../../core/services/menu/menu-item-action-importation.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
interface IPageAc0055 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}

interface IAc0055Params {
    ajocleintref: string,
    daccleint: string,
    id: string,
    isforage: string,
    mnetab: string
}

/* @ngInject */
export default function Ac0055Controller(
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    $stateParams: IAc0055Params,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemAction: IMenuItemActionClass,
    ac0005Route: IRoute,
    ac0010Route: IRoute,
    MenuItemActionImportation: IMenuItemActionImportationClass,
    $scope: IScope) {

    const vm: IPageAc0055 = this;
    vm.$onInit = $onInit;
    function $onInit() {
        vm.valeursEcran = ecranDetails.valeurs;

        const formulaireConfirmation = (isETC()) ?
            new Formulaire([
                new FormulaireItem('mnetabnew', {
                    default: getMnetab(),
                    hidden: true,
                    ignoreEtat: true
                }),
                new FormulaireItem('etccleint', {
                    required: true,
                    largeur: 100,
                    ignoreEtat: true,
                    readonly: true,
                    default: () => getEtccleintCri()
                }),
                new FormulaireItem('ajodscnew', {
                    required: true,
                    largeur: 100,
                    ignoreEtat: true
                }),
                new FormulaireItem('etccleintnew', {
                    default: () => getDataEtc(),
                    hidden: true,
                    ignoreEtat: true
                }),
                new FormulaireItem('ajocleintref', {
                    default: () => getDataEtc(),
                    hidden: true,
                    ignoreEtat: true
                })

            ]) : new Formulaire([
                new FormulaireItem('mnetabnew', {
                    default: getMnetab(),
                    hidden: true,
                    ignoreEtat: true
                }),
                new FormulaireItem('daccleint', {
                    required: true,
                    largeur: 100,
                    ignoreEtat: true,
                    readonly: () => $stateParams?.isforage || (!$stateParams?.isforage && isFormulaireConfirmationReadonly()),
                    default: () => getDaccleintCri()
                }),
                new FormulaireItem('ajodscnew', {
                    required: true,
                    largeur: 100
                }),
                new FormulaireItem('daccleintnew', {
                    default: () => $stateParams.id || getDataDaccleintNew(),
                    hidden: true
                })//vm?.valeursEcran?.daccleint__dacnumdoc
            ])

        const formulaire = (isETC()) ? new Formulaire([
            new FormulaireItem('ajocleintref'),
            new FormulaireItem('usrnomcre'),
            new FormulaireItem('datcre'),
            new FormulaireItem('ajodsc'),
            new FormulaireItem('ajoflgori'),
            new FormulaireItem('ajoaddseq'),
        ]) :
            new Formulaire([
                new FormulaireItem('ajocleintref'),
                new FormulaireItem('usrnomcre'),
                new FormulaireItem('datcre'),
                new FormulaireItem('ajodsc'),
                new FormulaireItem('ajoflgori'),
                new FormulaireItem('ajoaddseq'),
                new FormulaireItem('daccleint', {
                    hidden: true,
                    default: () => $stateParams.id
                })
            ])

        const criteresSuggeres = (isETC()) ?
            new Formulaire([
                new FormulaireItem('mnecri', {
                    default: () => getMnetab(),
                    hidden: true,
                    ignoreEtat: true
                }),
                new FormulaireItem('etccleint', {
                    required: true,
                    readonly: () => $stateParams?.isforage,
                    default: () => getEtccleintCri(),
                    ignoreEtat: true
                }),
                new FormulaireItem('refcleint', {
                    readonly: () => true,
                    default: vm.valeursEcran.refcleint__refcod,
                    ignoreEtat: true
                })
            ]) :
            new Formulaire([
                new FormulaireItem('mnecri', {
                    default: () => getMnetab(),
                    hidden: true,
                    ignoreEtat: true
                }),
                new FormulaireItem('daccleint', {
                    required: true,
                    ignoreEtat: true,
                    readonly: () => $stateParams?.isforage,
                    default: () => getDaccleintCri()
                }),
                new FormulaireItem('refcleint', {
                    readonly: () => true,
                    default: vm.valeursEcran.refcleint__refcod,
                    ignoreEtat: true
                })
            ])

        vm.menuItemImage = new MenuItemActionImportation(
            'LBL_AJOUT_DOC',
            'BOUAJO',
            () => getId(),
            {
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_AJOUT_DOC',
                    formulaire: formulaireConfirmation,
                },
                typesFichiers: ['.pdf'],
                successAction: () => vm.multiOccurrence.fetchDataList(),
                icon: 'add_circle',
                disabled: () => {
                    return isETC()
                        ? !vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.etccleint
                        : !vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.daccleint;
                }
            }
        );

        vm.multiOccurrenceOptions = {
            fonctions: {
                rechercheCollapsable: false,
                criteresSuggeresVisibles: $stateParams?.isforage !== "1",
                boutonDupliquer: false,
                selectionCycle:false
            },
            actionsNouveaux: new Menu([
                vm.menuItemImage
            ]),
            actionsMoreLigne: new Menu([
                new MenuItemAction(
                    'LBL_BTN_SUPPRIMER',
                    'BOUSUP',
                    () => ({}),
                    {
                        icon: 'delete',
                        fonction: 'BOUSUP',
                        iconButton: false,
                        successAction: () => {
                            vm.multiOccurrence.fetchDataList();
                        }
                    }
                )
            ]),
            criteresSuggeres: criteresSuggeres,
            fileDownloadPreview: {
                isRowWithBtnFunction: null,
                col: {
                    nom: 'ajoblb',
                    largeur: 110,
                },
                download: {
                    hidden: () => false
                },
                preview: {
                    hidden: () => false
                },
                url: {
                    nomFonctionDownload: 'BOUSOR',
                    nomFonctionPreview: 'BOUSOR',
                    srccodBloc: 'ac0055',
                    getCleFunction: (data: any): string => data['ajocleint']
                }
            },
            colonnesVisibles: [
                {
                    nom: (isETC()) ? 'etcnumdoc' : 'dacnumdoc',
                    largeur: 150,
                    menu: [
                        new MenuItemForage(
                            '',
                            (isETC()) ? ac0005Route.NAME : ac0010Route.NAME,
                            (rowData: any) => ({
                                id: (isETC()) ? rowData.ajocleintref : rowData.doccleint
                            }),
                            {
                                iconButton: true
                            }
                        )
                    ]
                },
                { nom: (isETC()) ? 'etcdsc' : 'dacdsc', largeur: 200 },
                { nom: 'usrnomcre', largeur: 160 },
                { nom: 'datcre', largeur: 160 },
                { nom: 'ajodsc', largeur: 300 },
                { nom: 'ajoflgori', largeur: 100 },
                { nom: 'ajoaddseq', largeur: 120 },
            ],
            formulaire: formulaire,
            colonnesCachees: [
                'ajomnetabref',
                'ajocleintref',
                'ajocleint',
                'ajoblb',
                'daccleint',
                'doccleint'
            ]
        };

        $scope.$watch('vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint', (newValue) => {
            if (newValue) {
                vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint = newValue
                vm.multiOccurrence.emit('etatUpdate')
            }
        });

        $scope.$watch('vm.multiOccurrence.etatSelected.criteresSuggeresData.etccleint', (newValue) => {
            if (newValue && vm?.multiOccurrence?.etatSelected?.criteresSuggeresData) {
                vm.multiOccurrence.etatSelected.criteresSuggeresData.etccleint = newValue
                vm.multiOccurrence.emit('etatUpdate')
            }
        });

        $scope.$watch('vm.multiOccurrence.initialized', (initialized: boolean) => {
            if (initialized && $stateParams.id) {
                if (isETC()) {
                    vm.multiOccurrence.etatSelected.criteresSuggeresData.etccleint = $stateParams.id
                    vm.multiOccurrence.etatSelected.criteresSuggeresData.etccleint__etcdsc = vm.valeursEcran.etccleint__etcdsc
                    vm.multiOccurrence.etatSelected.criteresSuggeresData.etccleint__etcnumdoc = vm.valeursEcran.etccleint__etcnumdoc

                } else {
                    vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint = $stateParams.id
                    vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint__dacdsc = vm.valeursEcran.daccleint__dacdsc
                    vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint__dacnumdoc = vm.valeursEcran.daccleint__dacnumdoc
                }
                vm.multiOccurrence.emit('etatUpdate')
            }
        });
    }

    function isFormulaireConfirmationReadonly(): boolean {
        return Boolean(vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.daccleint__dacnumdoc)
    }
    function getDataDaccleintNew() {
        return vm?.valeursEcran?.daccleint || vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint
    }

    function getDataEtc() {
        return vm?.multiOccurrence?.etatSelected?.criteresSuggeresData?.etccleint
    }

    function getId() {
        const id = (isETC()) ? { id: getDataEtc() } : { id: $stateParams.id || vm?.valeursEcran?.daccleint || vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint }
        return id
    }

    function getDaccleintCri() {
        if ($stateParams?.isforage)
            return vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint__dacnumdoc
        return undefined
    }

    function getEtccleintCri() {
        if ($stateParams?.isforage)
            return vm.multiOccurrence.etatSelected.criteresSuggeresData.etccleint__etcnumdoc
        return undefined
    }

    function getMnetab() {
        return ecranDetails?.params.p_mnetab || $stateParams.mnetab
    }
    function isETC() {
        return getMnetab() === 'ETC'
    }
}
